// Trending destinations featured in the nav and on the home page.
// Each value must match a canonical location tag produced by the ETL (location_tags).
export const FEATURED_LOCATIONS = ["Rishikesh", "Goa", "Kerala", "Dharamsala"];

// Short marketing intros used on each location page (SEO + UX).
export const LOCATION_INTROS = {
  Rishikesh:
    "Known as the Yoga Capital of the World, Rishikesh sits on the banks of the Ganges in the Himalayan foothills. It is the top destination for traditional Hatha yoga, meditation and 200/300-hour teacher training retreats.",
  Goa:
    "Goa pairs beachside relaxation with yoga. Expect Vinyasa and Ashtanga retreats, wellness escapes and teacher trainings just steps from the Arabian Sea.",
  Kerala:
    "Kerala is India's home of Ayurveda. Combine yoga with authentic Ayurvedic treatments, detox programs and wellness retreats amid backwaters and lush greenery.",
  Dharamsala:
    "Set in the Himalayas near McLeod Ganj, Dharamsala is a serene base for meditation, mindfulness and yoga retreats with mountain views.",
};

export function locationToSlug(location) {
  return String(location || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

// Convert a URL slug back into a display/query location label (Title Case).
export function slugToLocation(slug) {
  return String(slug || "")
    .trim()
    .toLowerCase()
    .split("-")
    .filter(Boolean)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export function getLocationIntro(location) {
  return (
    LOCATION_INTROS[location] ||
    `Discover yoga retreats, meditation retreats, wellness programs and teacher training courses in ${location}. Compare dates, styles, meals, ratings and prices in one place.`
  );
}
